import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const KEY = 'radar_gdpr_v1';

export function useConsent() {
  const [consent, setConsent] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
  });
  const save = (analytics) => {
    const v = { essential: true, analytics, ts: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(v));
    setConsent(v);
  };
  return { consent, acceptAll: () => save(true), rejectAll: () => save(false), reset: () => { localStorage.removeItem(KEY); setConsent(null); } };
}

export default function CookieBanner() {
  const { consent, acceptAll, rejectAll } = useConsent();
  const [visible, setVisible] = useState(false);
  const [details, setDetails] = useState(false);

  useEffect(() => {
    if (!consent) { const t = setTimeout(() => setVisible(true), 700); return () => clearTimeout(t); }
  }, [consent]);

  if (!visible || consent) return null;

  return (
    <div className="gdpr-banner" role="dialog" aria-label="Gestion des cookies" style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#fff', borderTop: '2px solid var(--radar-orange)',
      boxShadow: '0 -8px 40px rgba(26,10,0,.13)',
      padding: 'clamp(16px,3vw,24px) var(--px, clamp(16px,5vw,40px))',
    }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 14 }}>
          <span style={{ fontSize: 22, flexShrink: 0 }}>🍪</span>
          <div>
            <p style={{ fontWeight: 700, fontSize: 15, marginBottom: 5 }}>Ce site utilise des cookies</p>
            <p style={{ fontSize: 13, color: '#5A4A3C', lineHeight: 1.6 }}>
              Des cookies essentiels assurent le bon fonctionnement du site (authentification, sécurité).
              Avec votre accord, des cookies analytiques anonymes nous aident à améliorer votre expérience.{' '}
              <Link to="/confidentialite" style={{ color: 'var(--radar-orange)', textDecoration: 'underline' }}>En savoir plus</Link>
            </p>
          </div>
        </div>

        {/* Detail toggle */}
        <button onClick={() => setDetails(v => !v)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: 'var(--radar-mid)', fontFamily: 'var(--font-mono)', letterSpacing: '.05em', textTransform: 'uppercase', marginBottom: details ? 14 : 0, display: 'flex', alignItems: 'center', gap: 5 }}>
          <span style={{ display: 'inline-block', transition: 'transform .2s', transform: details ? 'rotate(90deg)' : 'none' }}>▶</span> Personnaliser
        </button>

        {details && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16, background: 'var(--radar-light)', borderRadius: 8, padding: '14px 16px' }}>
            {[
              { name: 'Cookies essentiels', always: true,  desc: 'Session JWT, sécurité, préférences. Nécessaires au fonctionnement — toujours actifs.' },
              { name: 'Cookies analytiques', always: false, desc: 'Mesure d\'audience anonyme. Aucune donnée personnelle transmise à des tiers.' },
            ].map(row => (
              <div key={row.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                <div>
                  <p style={{ fontWeight: 600, fontSize: 13, marginBottom: 2 }}>{row.name}</p>
                  <p style={{ fontSize: 12, color: 'var(--radar-mid)', lineHeight: 1.5 }}>{row.desc}</p>
                </div>
                <span style={{ flexShrink: 0, padding: '3px 10px', borderRadius: 4, fontSize: 10, fontFamily: 'var(--font-mono)', background: row.always ? 'rgba(46,125,50,.1)' : 'rgba(217,79,0,.1)', color: row.always ? '#2E7D32' : 'var(--radar-orange)' }}>
                  {row.always ? 'Obligatoire' : 'Optionnel'}
                </span>
              </div>
            ))}
          </div>
        )}

        {/* Actions */}
        <div className="gdpr-banner-actions" style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: details ? 0 : 4 }}>
          <button onClick={() => { acceptAll(); setVisible(false); }}
            style={{ flex: '1 1 150px', padding: '12px 20px', background: 'var(--radar-gradient)', color: '#fff', border: 'none', borderRadius: 4, fontFamily: 'var(--font-mono)', fontSize: 11, cursor: 'pointer', letterSpacing: '.04em', textTransform: 'uppercase', fontWeight: 700 }}>
            Tout accepter
          </button>
          <button onClick={() => { rejectAll(); setVisible(false); }}
            style={{ flex: '1 1 150px', padding: '12px 20px', background: 'none', color: 'var(--radar-dark)', border: '1.5px solid rgba(140,106,90,.3)', borderRadius: 4, fontFamily: 'var(--font-mono)', fontSize: 11, cursor: 'pointer', letterSpacing: '.04em', textTransform: 'uppercase' }}>
            Essentiels seulement
          </button>
          <button onClick={() => { rejectAll(); setVisible(false); }}
            style={{ flex: '0 0 auto', padding: '12px 14px', background: 'none', color: 'var(--radar-mid)', border: 'none', fontFamily: 'var(--font-mono)', fontSize: 11, cursor: 'pointer', letterSpacing: '.04em', textTransform: 'uppercase', textDecoration: 'underline' }}>
            Refuser
          </button>
        </div>
      </div>
    </div>
  );
}
